<template>
  <div :class="['search-tab', type]">
    <el-tabs type="card" v-model="currentTab" @tab-change="handleTabChange">
      <el-tab-pane name="1">
        <template #label>
          <span class="custom-tabs-label">
            <img :src="icon.hIcon" alt="" srcset="" />
            <span class="fs-xl">{{ label }}综合STEM结果</span>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane name="2" v-if="type !== 'college'">
        <template #label>
          <span class="custom-tabs-label">
            <img :src="icon.plusIcon" alt="" srcset="" />
            <span class="fs-xl">{{ label }}学科STEM结果</span>
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, reactive, ref } from 'vue'

import hIcon from '@/assets/icons/hospital.png'
import plusIcon from '@/assets/icons/plus.png'

import INFO from '../../constant.js'

const emits = defineEmits(['tab-change'])

const props = defineProps({
  type: {
    type: String
  }
})
const currentTab = ref('1')

const handleTabChange = (value) => {
  // if (currentTab.value === value) return
  emits('tab-change', value)
}

const icon = {
  hIcon,
  plusIcon
}
const label = INFO[props.type].name
</script>

<style lang="scss" scoped>
.search-tab {
  ::v-deep {
    .el-tabs {
      background-color: rgba($color: #000000, $alpha: 0);

      &__nav {
        border: none;
      }
      &__header {
        background-color: rgba($color: #000000, $alpha: 0);
        border-bottom: none;
        margin-bottom: 0;
      }
      .custom-tabs-label {
        display: flex;
        align-items: center;
        img {
          width: 1.5625rem;
          vertical-align: text-bottom;
          margin-right: 0.125rem;
        }
      }
      &__item {
        background-color: #d4d4d4;
        color: #000;
        // transition: all 0.6s;
        border: none;
        line-height: 2.5rem;
        height: 2.5rem;

        &.is-active {
          background: linear-gradient(180deg, #0899a8, #01626b);
          color: #fff;
          position: relative;
          padding-right: 3.75rem;

          &:hover {
            color: #fff !important;
            &::after {
              opacity: 1 !important;
            }
          }
          &::after {
            position: absolute;
            content: '';
            right: 0;
            top: 0;
            width: 0;
            height: 0;
            line-height: 0;
            font-size: 0;
            border-style: solid;
            border-color: transparent;
            border-width: 0 30px 40px 0px;
            border-right-color: #d4d4d4;
            border-top-color: #d4d4d4;
          }
        }
        &:not(.is-disabled):hover {
          color: #000;
          opacity: 0.9;
        }
        &:nth-child(2) {
          &.is-active {
            padding-left: 60px;
            &::after {
              left: 0;
              right: unset;
              border-right-color: unset;
              border-width: 0 0 40px 30px;
              border-left-color: #d4d4d4;
              border-top-color: #d4d4d4;
            }
          }
        }
      }
      &__content {
        // border: 1px solid #d4d4d4;
      }
    }
  }
  &.college {
    ::v-deep {
      .el-tabs {
        &__item {
          background-color: #d4d4d4;
          color: #000;
          // transition: all 0.6s;
          border: none;

          &.is-active {
            background: linear-gradient(180deg, #0899a8, #01626b);
            color: #fff;
            position: relative;
            padding-right: 60px;

            &:hover {
              color: #fff !important;
            }
            &::after {
              border-width: 0 1.875rem 2.375rem 0px;
              border-right-color: #fff;
              border-top-color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
